import type { InlineCode } from 'mdast';

import type { State } from '../state';

export function inlineCode(state: State, node: InlineCode): void {
	if (!state.schema.marks.code) {
		// Gracefully degrade: render as plain text when schema has no code mark
		state.addText(node.value);
		return;
	}
	const mark = state.schema.marks.code.create();
	state.openMark(mark);
	state.addText(node.value);
	state.closeMark(mark);
}
